import { useQueryClient } from "@tanstack/react-query";
import type { FunctionComponent } from "react";
import { useCallback } from "react";

import Sidebar from "~/components/Sidebar";
import CreateProjectTagForm
	from "~/modules/admin/components/AdminView/components/AdminProjectTagsSection/components/CreateProjectTagSidebar/components/CreateProjectTagForm";
import { ALL_PROJECT_TAGS_QUERY_KEY } from "~/modules/project/api/projectTag/projectTagQueries.ts";
import type { ProjectTagTypeId } from "~/modules/project/api/projectTag/projectTagTypes.ts";

type CreateDeliverableTagSidebarProps = {
	isOpen: boolean;
	onClose: () => void;
	tagTypeId: ProjectTagTypeId;
};

const CreateProjectTagSidebar: FunctionComponent<CreateDeliverableTagSidebarProps> = ({
	isOpen,
	onClose,
	tagTypeId,
}) => {
	const queryClient = useQueryClient();
	const handleSuccess = useCallback(async () => {
		await queryClient.refetchQueries({ queryKey: ALL_PROJECT_TAGS_QUERY_KEY });
		onClose();
	}, [onClose, queryClient]);

	return (
		<Sidebar closeOnOutsideClick={false}
				 open={isOpen}
				 setOpen={() => onClose()}>
			{isOpen && <CreateProjectTagForm onSuccess={handleSuccess}
											 onCancel={onClose}
											 tagTypeId={tagTypeId}
			/>}
		</Sidebar>
	);
};

export default CreateProjectTagSidebar;
